// extracted by mini-css-extract-plugin
export var closeButton = "_jr-1";
export var closeX = "_jr-3";
export var container = "_jr-0";
export var image = "_jr-2";